import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function ResourcesIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 2C18.5523 2 19 2.44772 19 3L19 9C19 9.55229 18.5523 10 18 10C17.4477 10 17 9.55228 17 9L17 3C17 2.44772 17.4477 2 18 2Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 6C22 6.55229 21.5523 7 21 7L15 7C14.4477 7 14 6.55228 14 6C14 5.44771 14.4477 5 15 5L21 5C21.5523 5 22 5.44772 22 6Z"
        fill={color}
      />
      <rect
        x="3"
        y="3"
        width="6"
        height="6"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="1.41421"
        y="17.6567"
        width="6"
        height="6"
        rx="1"
        transform="rotate(-45 1.41421 17.6567)"
        stroke={color}
        strokeWidth="2"
      />
      <rect
        x="15"
        y="15"
        width="6"
        height="6"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
    </SvgIcon>
  );
}
